import React, { useState, useMemo} from 'react';
import dateFormat from "dateformat";

const KPIsContext = React.createContext();

export const KPIsProvider = (props) => {

    
    const [values, setValues] = useState([]);

    const sumTotal = (field, year = null) => {

        let totalInci = 0;
        let endKm="end_km";
        let startKm="start_km";
        let sumKm=0;
        let promedioTotal=0;
        let data = year == null ? values : values.filter(item => item.attributes.year == year);
        data.map(item => {
            if(item.attributes[field] != null){
                totalInci += item.attributes[field];
                if(item.attributes[endKm]!=undefined && item.attributes[endKm]!=null)
                {
                    sumKm += (item.attributes[endKm]-item.attributes[startKm]);
                    promedioTotal = totalInci / sumKm;
                }
                else
                {
                    promedioTotal = totalInci;
                }
                
                
            }                 
        });
        return promedioTotal
    }


     const sumTotalPorcentaje = (field, year = null) => {

        let totalInci = 0;
       
        let data = year == null ? values : values.filter(item => item.attributes.year == year);
        data.map(item => {
            if(item.attributes[field] == 1){
                totalInci ++;               
            }   
                          
        });

        return totalInci
    }

    const formatNumber = (x) => {
        return x != 0 ? (Number.parseFloat(x).toFixed(2)) : "";
    }

    const calculoPromedioPorcentaje = (field, year = null) => {
        
        let result = sumTotalPorcentaje(field, year)

        if(result == 0){
            return "";
        }else{
            let results = (result / values.length) * 100;
            return formatNumber(results);
        }
    }

    const calculoPromedio = (field, year = null) => {
        let result = sumTotal(field, year)

        if(result == 0){
            return "";
        }else{
            let results = result / values.length;
            return formatNumber(results);
        }
    }

    const calculoPer100km = (field, year = null) => {
        let result = sumTotal(field, year)

        if(result == 0){
            return "";
        }else{
            let results = (values.length / result) * 100;
            return formatNumber(results);
        }
    }

    const calculoTrafficRoadS = (field, year) => {
        
        let totalInci = 0;

        let dataFiltered = values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes.total_traffic_crashes_serious_inj != null) {

                totalInci += item.attributes.total_traffic_crashes_serious_inj * 1000 / item.attributes[field]
            }
        });
        return totalInci != 0 ? formatNumber(totalInci / dataFiltered.length) : "";
    }

    const calculoTTI = (field, year = null) => {

        let totalInci = 0;

        let dataFiltered = year == null ? values : values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[field] != null){
                totalInci += item.attributes[field] / (item.attributes.end_km - item.attributes.start_km) / (item.attributes.speed_limit*60)
            }
            
        })

        return totalInci != 0 ? formatNumber(totalInci / dataFiltered.length) : "";
    }

    const calculoTTIBased = (field, year = null) => {

        let totalInci = 0;

        let dataFiltered = year == null ? values : values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[field] != null){
                totalInci += item.attributes[field] - (item.attributes.end_km - item.attributes.start_km) / (item.attributes.speed_limit*60)
            }
            
        })

        return totalInci != 0 ? formatNumber(totalInci / dataFiltered.length) : "";
    }

    const calculoAveTravel = (field, year = null) => {
        
        let totalInci = 0;

        let dataFiltered = year == null ? values : values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[field] != null && item.attributes[field] != 0){
                totalInci += item.attributes[field] / (item.attributes.end_km - item.attributes.start_km) 
            }
            
        })

        return totalInci != 0 ? formatNumber(totalInci / values.length) : "";
    }

    const calculoTrafficRoadNPM = (field, year = null) => {

        let totalInci = 0;

        let dataFiltered = year == null ? values : values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[field] != null && item.attributes[field] != 0 && item.attributes.total_traffic_flow_aadt != null){
                totalInci += 1000000 * (item.attributes[field] / (item.attributes.total_traffic_flow_aadt * (item.attributes.end_km - item.attributes.start_km) * 365))
            }
            
        })

        return totalInci != 0 ? formatNumber(totalInci / dataFiltered.length) : "";
    }

    const calculoYesNo = (field, year = null) => {

        let count = 0;

        let dataFiltered = year == null ? values : values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[field] == 1 || item.attributes[field] == "yes" || item.attributes[field] == true){
                count++;
            }
        });

        return count != 0 ? formatNumber((count*100) / dataFiltered.length) : "";
    }
    const parseDate = (dateStr) => {
        // Extraer año, mes y día de la cadena
        const year = parseInt(dateStr.substring(0, 4), 10);
        const month = parseInt(dateStr.substring(4, 6), 10) - 1; // Meses en JS van de 0 a 11
        const day = parseInt(dateStr.substring(6, 8), 10);
        return new Date(year, month, day);
    }
    const calculoDias = (curr, init, actual, year) => {

        let totalInci = 0;

        let dataFiltered = values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[init] != null) {
                let formatCurr = dateFormat(item.attributes[curr != null ? curr : actual], "yyyymmdd");
                let formatInit = dateFormat(item.attributes[init], "yyyymmdd");

                let date1 = parseDate(formatInit);
                let date2 = parseDate(formatCurr);
                
                let yearsDiff = date2.getFullYear() - date1.getFullYear();
                let monthsDiff = date2.getMonth() - date1.getMonth();
                if(yearsDiff>=0)
                {
                    totalInci += (yearsDiff * 12) + monthsDiff; 
                }                
            }
        });
        //return totalInci != 0 ? formatNumber(totalInci / dataFiltered.length) : 0;
        return totalInci;
    }

    const calculoPeriod = (actual, forecast, year) => {
        let totalInci = 0;

        let dataFiltered = values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[actual] != null && item.attributes[forecast] != null && item.attributes[actual] != 0) {
                totalInci += (item.attributes[actual] / item.attributes[forecast]) 
            }
        });
        return totalInci != 0 ? formatNumber(totalInci / dataFiltered.length) : "";
    }

    const calculoPerType = (field, value, year = null) => {
        let totalInci = 0;

        let dataFiltered = year == null ? values : values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[field] == types[value])
                totalInci++
        });

        return totalInci != 0 ? formatNumber((totalInci*100) / dataFiltered.length) : "";
    }

    const calculoPerTypeStatus = (field, year) => {
        let totalInci = 0;

        let dataFiltered = values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes[field] != null){
                totalInci++
            }
        });

        return totalInci != 0 ? formatNumber((totalInci*100) / dataFiltered.length) : "";
    }

    const calculoFundingSources = (field, year) => {
        let totalInci = 0;
        let totalPerType = 0;

        let dataFiltered = values.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            if(item.attributes.proj_fund_nat_budg != null) totalInci+=item.attributes.proj_fund_nat_budg
            if(item.attributes.proj_fund_wb != null) totalInci+=item.attributes.proj_fund_wb
            if(item.attributes.proj_fund_ebrd != null) totalInci+=item.attributes.proj_fund_ebrd
            if(item.attributes.proj_fund_eib != null) totalInci+=item.attributes.proj_fund_eib
            if(item.attributes.other_ifi != null) totalInci+=item.attributes.other_ifi
            if(item.attributes.concessions != null) totalInci+=item.attributes.concessions
            if(item.attributes.eu_fund != null) totalInci+=item.attributes.eu_fund
            if(item.attributes.other_fund != null) totalInci+=item.attributes.other_fund

            if(item.attributes[field] != null) totalPerType+=item.attributes[field]
        });

        return totalInci != 0 ? formatNumber((totalPerType*100) / totalInci) : "";
    }

    const calculoLocks = () => {
        let double_lock = 0;
        let single_lock = 0;
        let width = 0;

        values.map(item => {
            double_lock += item.attributes.double_lock ?? 0;
            single_lock += item.attributes.single_lock ?? 0;
            width += item.attributes.width ?? 0;
        })

        return double_lock + single_lock + width;
    }

    const calculoperTypeLock = (field) => {
        let totalInci = 0;
        let totalPerType = 0;

        values.map(item => {
            if(item.attributes.double_lock != null) totalInci+=item.attributes.double_lock
            if(item.attributes.single_lock != null) totalInci+=item.attributes.single_lock

            if(item.attributes[field] != null) totalPerType+=item.attributes[field]
        });

        return totalInci != 0 ? formatNumber((totalPerType*100) / totalInci) : "";
    }

    const calculoChange = (field, year) => {
        let totalInci = 0;

        let dataFiltered = values.filter(item => item.attributes.year == year);
        
        dataFiltered.map(data => {
            totalInci += data.attributes[field] ?? 0
        })

        return formatNumber(totalInci);
    }

    const types = {
        "infrastructure": "New infrastructure",
        "reconstruction": "Reconstruction/rehabilitation",
        "maintenances": "Maintenance",
        "horizontal": "Horizontal/policy measure",
        "workCur": "Works currently under execution",
        "tenderWork": "Tender for works/design-build on-going",
        "designTender": "Design/Tender Dossier for DB under preparation",
        "tenderOngoing": "Tender for design on-going or about to be start",
        "finOngoing": "Financing source identified (principle agreement reached), procedures on-going",
        "finProceduresNotyetStarted": "Financing source identified (principle agreement reached), procedures not-yet-started",
        "finSourceNotInd": "Financing source not identified",
        "feasOnGoing": "Feasibility study on-going",
        "feasUnderTen": "Feasibility study under tendering",
        "financing": "Financing for feasibility study secured, procurement not yet started"
    }
    
    const value = useMemo(() => {
        return ({
            sumTotal,
            sumTotalPorcentaje,
            formatNumber,
            calculoPromedioPorcentaje,
            calculoPromedio,
            calculoPer100km,
            calculoTrafficRoadS,
            calculoTrafficRoadNPM,
            calculoTTI,
            calculoTTIBased,
            calculoAveTravel,
            calculoYesNo,
            calculoDias,
            calculoPeriod,
            calculoPerType,
            calculoPerTypeStatus,
            calculoFundingSources,
            calculoLocks,
            calculoperTypeLock,
            calculoChange,
            setValues,
            values
        });
    }, [values]);

    return <KPIsContext.Provider value={value} {...props} />
}

export const useKPIs = () => {
    const context = React.useContext(KPIsContext);

    if(!context)
        throw new Error("Se debe hacer el wrapper con el KPIsContext");

    return context;
}